import { graphql } from 'gatsby';
import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import PodcastDetailHeroSection from 'components/Podcast/PodcastDetailHeroSection';
import PodcastAboutShowSection from 'components/Podcast/PodcastAboutShowSection';
import PodcastDetailContentSection from 'components/Podcast/PodcastDetailContentSection';
import ModalMarketingForm from 'components/ModalMarketingForm';
import CardBlock from 'components/CardBlock';
import StickyMobileForm from 'components/Form/StickyMobileForm';
import { truncateText } from 'utils/text';
import podcastIcon from 'images/podcast-gray.svg';
import { format } from 'utils/date';
import ToolboxLayout from 'layouts/toolboxLayout';
import useSideBarPodcast from 'hooks/useSideBarPodcast';
import usePodcastEpisodes from 'hooks/usePodcastEpisodes';
import scroll from 'utils/smoothScroll';
import useDefaultSubscribeForm from 'hooks/useDefaultSubscribeForm';

const PodcastDetailPage = props => {
  const {
    id,
    podcastTitle,
    podcastDate,
    seo: seoData,
    series,
    minutes,
    coverPhoto,
    taxonomy,
    episode,
    episodeId,
    relatedVideos,
    overview,
    summary,
    episodeSections,
    aboutTheShow,
    spotifyLink,
    applePodcastsLink,
    googlePodcastLink,
    sideBar,
  } = props.data.contentfulPodcast;
  const defaultPodcastSideBar = useSideBarPodcast();
  const [isModalOpen, toggleIsModalOpen] = useState(false);
  const form = props?.data?.contentfulInlineMarketingForm;
  const subscribeForm = useDefaultSubscribeForm();
  const moreEpisodes = usePodcastEpisodes(id, series);
  const data = moreEpisodes
    ? Array.isArray(moreEpisodes)
      ? moreEpisodes
      : [moreEpisodes]
    : moreEpisodes;

  const cards = {
    title: 'More episodes',
    description: '',
    bgColor: 'Alice Blue',
    cardType: 'Image',
    bodyType: 'simple',
    cards: data
      ? data.slice(0, 3).map(epi => {
          const podcastExcerpt =
            epi.node?.podExcerpt?.podExcerpt || epi.node?.excerpt?.content[0]?.content[0]?.value;
          const descriptionTrunc = truncateText(podcastExcerpt, 90);

          return {
            subTitle: `${epi?.node?.taxonomy?.topics.join(' • ')} • ${epi?.node?.minutes} minutes`,
            title: epi?.node?.podcastTitle,
            description: {
              description: descriptionTrunc,
            },
            cover: epi?.node?.cardPhoto?.image || epi?.node?.coverPhoto?.image,
            ctaLink: epi?.node?.seo?.pageUrl,
            markIcon: podcastIcon,
          };
        })
      : [],
  };

  const breadcrumbs = {
    data: [
      {
        title: 'Toolbox',
        icon: null,
        url: '/toolbox',
      },
      {
        title: 'Podcast',
        icon: podcastIcon,
        url: '/podcast',
      },
      {
        title: episode,
        icon: null,
        url: null,
      },
    ],
    absolute: true,
  };

  useEffect(() => {
    scroll();
  }, []);

  useEffect(() => {
    const formSubmitted = Cookies.get('toolbox_form_submission');

    if (!formSubmitted) {
      toggleIsModalOpen(true);
    }
  }, []);

  const onSuccess = () => {
    Cookies.set('toolbox_form_submission', 'true');
    toggleIsModalOpen(false);
  };

  return (
    <ToolboxLayout breadcrumbs={breadcrumbs} contentfulSeo={seoData} {...props}>
      {form && (
        <ModalMarketingForm
          isModalOpen={isModalOpen}
          onModalCancel={() => toggleIsModalOpen(false)}
          marketingForm={form}
          onFormSuccess={onSuccess}
          shouldRedirect={false}
        />
      )}

      <PodcastDetailHeroSection
        backgroundColor="#F5FCFF"
        subTitle={`${taxonomy.topics.join(' • ')} • ${minutes} minutes`}
        title={`${podcastTitle}`}
        created_date={format(podcastDate, 'MMMM D, YYYY')}
        coverPhoto={coverPhoto}
        episode={episode !== null && episode !== '' ? `Episode ${episode}` : 'Bonus Episode'}
        episodeId={episodeId}
        pageUrl={seoData.pageUrl}
      />

      <PodcastDetailContentSection
        overview={overview}
        episodeSections={episodeSections}
        summary={summary}
        relatedVideos={relatedVideos}
        applePodcastsLink={applePodcastsLink}
        googlePodcastLink={googlePodcastLink}
        spotifyLink={spotifyLink}
        moreEpisodes={moreEpisodes}
        sideBar={sideBar || defaultPodcastSideBar}
        sideBarRecommended={moreEpisodes}
        pageUrl={seoData.pageUrl}
      />

      {moreEpisodes && moreEpisodes.length > 0 && <CardBlock cols={3} data={cards} />}

      <PodcastAboutShowSection content={aboutTheShow} />
      <StickyMobileForm marketoForm={subscribeForm.marketoForm} />
    </ToolboxLayout>
  );
};

export default PodcastDetailPage;

export const PodcastDetailPageQuery = graphql`
  query PodcastBySlug($slug: String!) {
    contentfulPodcast(seo: { pageUrl: { eq: $slug } }) {
      ...Podcast
    }
    contentfulInlineMarketingForm(contentful_id: { eq: "6Leir6sWruCSskqB1vgQVB" }) {
      ...InlineMarketingForm
    }
  }
`;
